import {
  params, string, shape, arrayOf, bool, number, alias, extend, customType
} from '@thd-nucleus/data-sources';

const product = {
  itemId: string(),
  dataSources: string(),
  identifiers: shape({
    canonicalUrl: string(),
    itemId: string(),
    brandName: string(),
    productLabel: string(),
    productType: string()
  }),
  info: shape({
    label: string()
  }),
  media: shape({
    image: shape({
      url: string()
    }).client(),
    images: arrayOf(shape({
      url: string(),
      type: string(),
      subType: string(),
      sizes: arrayOf(string())
    }))
  }),
  badges: params({ storeId: string() }).arrayOf(shape({
    label: string()
  })),
  pricing: params({ storeId: string() }).shape({
    message: string(),
    original: number({ float: true }),
    mapAboveOriginalPrice: bool(),
    promotion: shape({
      dollarOff: number({ float: true })
    }),
    value: number({ float: true }),
    mapDetail: shape({
      mapPolicy: string(),
      mapSpecialPriceViolation: bool(),
      mapOriginalPriceViolation: bool(),
      percentageOff: number({ float: true }),
      dollarOff: number({ float: true })
    })
  }),
  reviews: shape({
    ratingsReviews: shape({
      totalReviews: string(),
      averageRating: string()
    })
  })
};

const bundleProduct = shape({
  category: string(),
  description: string(),
  idEndDate: string(),
  idPromoDetails: string(),
  idStartDate: string(),
  isAnchor: bool(),
  defaultQuantity: number(),
  product: shape(product),
  slot: shape({
    description: string(),
    isRequired: bool(),
    name: string(),
    order: string()
  })
});

export const ApplianceBundlesDataModel = {
  bundle: params({
    itemId: string().isRequired(),
    storeId: string(),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(shape({
        tier: string(),
        program: string()
      }))
    })
  }).shape({
    metadata: shape({
      type: string()
    }),
    products: arrayOf(bundleProduct)
  }),
  clientOnlyProduct: extend(alias('product').params({
    itemId: string().isRequired(),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(shape({
        tier: string(),
        program: string()
      }))
    })
  }).shape({
    itemId: string(),
    availabilityType: shape({
      discontinued: bool()
    }),
    fulfillment: params({ storeId: string() }).shape({
      fulfillmentOptions: arrayOf(shape({
        fulfillable: bool(),
        type: string(),
        services: arrayOf(shape({
          type: string(),
          locations: arrayOf(shape({
            isAnchor: bool(),
            inventory: shape({
              quantity: number()
            })
          }))
        }))
      }))
    })
  }), product),
  product: params({
    itemId: string().isRequired(),
    loyaltyMembershipInput: customType('LoyaltyMembershipInput').shape({
      svocID: string(),
      programTiers: arrayOf(shape({
        tier: string(),
        program: string()
      }))
    })
  }).shape(product),
  checkAvailability: params({
    itemIds: arrayOf(string().isRequired()).isRequired(),
    zipCode: string().isRequired(),
    localStoreId: string().isRequired()
  })
    .shape({
      fulfillmentOptions: arrayOf(shape({
        services: arrayOf(shape({
          deliveryAvailabilityDetail: arrayOf(shape({
            itemId: string(),
            assortmentStrategy: string()
          }))
        }))
      }))
    })
};